import axios from 'axios'
const BaseURL = process.env.VUE_APP_BASE_URL

export default {
    name: 'statuskaryawan',
    state: {
        statuskaryawan: []
    },
    getters: {
        getStatusKaryawan: state => {
            return state.statuskaryawan
        }
    },
    mutations: {
        STATUSKARYAWAN: (state, payload) => {
            state.statuskaryawan = payload
        },
    },
    actions: {
        FETCH_STATUSKARYAWAN(store) {
            return axios({
                method: "get",
                url: BaseURL + "./json/statusKaryawan.json"
            }).then(response => {
                store.commit('STATUSKARYAWAN', response.data)
            }).catch(err => {
                return err
            });
        },
    }
}
